module.exports = __webpack_public_path__ + "assets/img/dayu_m_kcjh.2d22220c.png";